// Components
import GoogleBannerAd from "../../react_components/ads/google_banner_ad";
import GoogleFeaturedContentModule from "../../react_components/ads/google_featured_content_module";
import NativeAd from "../../react_components/ads/native_ads/native_ad";

// Stores
import GoogleAdsStore from "../../react_stores/google_ads_store";
import ClickTrackingStore from "../../react_stores/click_tracking_store";

export const MobilePremiumCampaignComponents = {
  GoogleBannerAd,
  NativeAd,
  GoogleFeaturedContentModule,
};

export const MobilePremiumCampaignStores = {
  GoogleAdsStore,
  ClickTrackingStore,
};
